<!-- <app-preloader /> -->

<div class="page" id="top">

	<p-toast key="app-toast" position="bottom-center"></p-toast>
	<app-navbar />
	<main id="main">
		<router-outlet></router-outlet>
	</main>
	<app-footer />
</div>

